import { getSystemDefaultPath } from "@/stores/authStore";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/system/")({
  beforeLoad: () => {
    throw redirect({ to: getSystemDefaultPath() });
  },
});
